import { Box, Grid, Typography } from '@mui/material';
import Chart from '@/components/general/Chart';
import { Placeholders } from '@/types';

interface PulseReportComponentProps {
  labels: string[];
  averageByWeek: number[];
  totalAverage: number;
  totalAverageColorIndicator: string;
}

const PulseReportComponent = function ({
  labels,
  averageByWeek,
  totalAverage,
  totalAverageColorIndicator,
}: PulseReportComponentProps): JSX.Element {
  return (
    <Grid item md={12}>
      <Chart
        labels={labels}
        data={averageByWeek}
        title="Average Pulse"
        tooltipLabel="Average pulse"
        lineWithColorIndicator
        colorIndicator={totalAverageColorIndicator}
        data-testid="pulses-chart"
      >
        <Box marginTop={2}>
          <Typography color="primary" component="span">
            Average:{' '}
          </Typography>
          <Typography
            color={totalAverageColorIndicator}
            fontWeight={600}
            component="span"
            data-testid="total-average-pulse"
          >
            {totalAverage || Placeholders.NO_FILTERED_DATA}
          </Typography>
        </Box>
      </Chart>
    </Grid>
  );
};

export default PulseReportComponent;
